var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"vip-box"},[_c('img',{attrs:{"width":"70%","src":require("@/assets/images/icons/vip_box.png")}}),_c('p',[_vm._v("恭喜您")]),_c('p',[_vm._v("免费获得价值588元的180天VIP")]),_c('a',{staticClass:"btn",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.SetVipStatusFn(false)}}},[_vm._v(" 知道了 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }